// seasons.js — helpers for the season pages (/seasons, /seasons/2011-12).
// Seasons are start years (2011 = 2011/12), as in league.js.

import { seasonText } from "./data";

export const seasonSlug = (start) => `${start}-${String((start + 1) % 100).padStart(2, "0")}`;
export const seasonPath = (start) => `/seasons/${seasonSlug(start)}`;
export const seasonQuery = (start) => `season=${start}`;

// "2011-12" -> 2011, or null for anything that isn't a real season slug.
export function parseSeasonSlug(slug) {
  const m = /^(\d{4})-(\d{2})$/.exec(slug || "");
  if (!m) return null;
  const start = Number(m[1]);
  return (start + 1) % 100 === Number(m[2]) ? start : null;
}

// Each club plays every other twice, so a finished season has n(n-1) matches.
export const seasonComplete = (clubs, matches) => matches >= clubs * (clubs - 1);

// Clubs relegated from each season: three, except 1994/95, when four went
// down to cut the league from 22 clubs to 20.
export const relegationPlaces = (start) => (start === 1994 ? 4 : 3);

// "A", "A and B", "A, B and C"
export const listText = (items) =>
  items.length <= 1 ? items.join("") : `${items.slice(0, -1).join(", ")} and ${items[items.length - 1]}`;

// 1 -> "1st", 22 -> "22nd", 13 -> "13th"
export const ordinal = (n) => `${n}${["th", "st", "nd", "rd"][(n % 100 > 10 && n % 100 < 14) || n % 10 > 3 ? 0 : n % 10]}`;

// { season, label, table, complete } for every season in parseMatches data,
// newest first, with each season's final (or current) table.
export function seasonSummaries(data, tableFor) {
  return data.seasons
    .map((season) => {
      const table = tableFor(data, season, season);
      const matches = data.matches.filter((m) => m.season === season);
      const goals = matches.reduce((n, m) => n + m.hs + m.as, 0);
      return { season, label: seasonText(season), table, matches: matches.length, goals, complete: seasonComplete(table.length, matches.length) };
    })
    .reverse();
}
